import { getStr } from "../utils/simpleLocalisation";


export interface DisplayRect {
  left: number;
  right: number;
  width: number;

  top: number;
  bottom: number;
  height: number;

  cx: number
  cy: number
}

export const cache_helper: string = "empty";

export class helper {
  
  static log(){
    // dont remove - will break parcel compiling
    console.log('');
  }

  static createTextfield(sc:any, text:string|string[], textclass?:any , styles?:any ):Phaser.GameObjects.Text {
    let compiledStyle = {}
    if (textclass){
      compiledStyle = {...compiledStyle,...sc.getStyle(textclass),...styles }
    }    
    return new Phaser.GameObjects.Text(sc, 0,0, getStr(text), compiledStyle )
  }


  static getDisplayRect(sc:any|Phaser.Scene):DisplayRect{
    var holder = document.querySelector('#holder');
    var wii = holder ? holder.clientWidth : 0;
    var wi = sc.sys.game.canvas.clientWidth;
    var innerWidth = (1920 / wi) * wii;
    var innerHeight = 1080

    innerWidth = innerWidth > 1920 ? 1920 : innerWidth
    var left = (1920/2) - (innerWidth/2)

    return {
      left: left,
      right: left + innerWidth,
      width: innerWidth,
      cx: 1920/2 ,
      cy: 1080 / 2,
      top: 0,
      bottom: innerHeight,
      height: innerHeight
    }
  }
}